// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type { StudentRewardsRepresentation } from '../models/index'
import {
  StudentRewardsRepresentationFromJSON,
  StudentRewardsRepresentationToJSON,
} from '../models/index'

export interface ApiV1RewardsStudentIdRewardsGetRequest {
  studentId: string
  precinct?: string
}

export interface ApiV1RewardsStudentIdRewardsRewardIdPutRequest {
  studentId: string
  rewardId: string
}

/**
 *
 */
export class RewardsApi extends runtime.BaseAPI {
  /**
   * Gets the rewards that can be claimed for a student (Auth policies: StudentResourceRequirement) (Auth policies: StudentResourceRequirement)
   */
  async apiV1RewardsStudentIdRewardsGetRaw(
    requestParameters: ApiV1RewardsStudentIdRewardsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<StudentRewardsRepresentation>> {
    if (
      requestParameters.studentId === null ||
      requestParameters.studentId === undefined
    ) {
      throw new runtime.RequiredError(
        'studentId',
        'Required parameter requestParameters.studentId was null or undefined when calling apiV1RewardsStudentIdRewardsGet.',
      )
    }

    const queryParameters: any = {}

    if (requestParameters.precinct !== undefined) {
      queryParameters['precinct'] = requestParameters.precinct
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        this.configuration.apiKey('Authorization') // oauth2 authentication
    }

    const response = await this.request(
      {
        path: `/api/v1/rewards/{studentId}/rewards`.replace(
          `{${'studentId'}}`,
          encodeURIComponent(String(requestParameters.studentId)),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      StudentRewardsRepresentationFromJSON(jsonValue),
    )
  }

  /**
   * Gets the rewards that can be claimed for a student (Auth policies: StudentResourceRequirement) (Auth policies: StudentResourceRequirement)
   */
  async apiV1RewardsStudentIdRewardsGet(
    requestParameters: ApiV1RewardsStudentIdRewardsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<StudentRewardsRepresentation> {
    const response = await this.apiV1RewardsStudentIdRewardsGetRaw(
      requestParameters,
      initOverrides,
    )
    return await response.value()
  }

  /**
   *  (Auth policies: StudentResourceRequirement) (Auth policies: StudentResourceRequirement)
   */
  async apiV1RewardsStudentIdRewardsRewardIdPutRaw(
    requestParameters: ApiV1RewardsStudentIdRewardsRewardIdPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<number>> {
    if (
      requestParameters.studentId === null ||
      requestParameters.studentId === undefined
    ) {
      throw new runtime.RequiredError(
        'studentId',
        'Required parameter requestParameters.studentId was null or undefined when calling apiV1RewardsStudentIdRewardsRewardIdPut.',
      )
    }

    if (
      requestParameters.rewardId === null ||
      requestParameters.rewardId === undefined
    ) {
      throw new runtime.RequiredError(
        'rewardId',
        'Required parameter requestParameters.rewardId was null or undefined when calling apiV1RewardsStudentIdRewardsRewardIdPut.',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        this.configuration.apiKey('Authorization') // oauth2 authentication
    }

    const response = await this.request(
      {
        path: `/api/v1/rewards/{studentId}/rewards/{rewardId}`
          .replace(
            `{${'studentId'}}`,
            encodeURIComponent(String(requestParameters.studentId)),
          )
          .replace(
            `{${'rewardId'}}`,
            encodeURIComponent(String(requestParameters.rewardId)),
          ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    if (this.isJsonMime(response.headers.get('content-type'))) {
      return new runtime.JSONApiResponse<number>(response)
    } else {
      return new runtime.TextApiResponse(response) as any
    }
  }

  /**
   *  (Auth policies: StudentResourceRequirement) (Auth policies: StudentResourceRequirement)
   */
  async apiV1RewardsStudentIdRewardsRewardIdPut(
    requestParameters: ApiV1RewardsStudentIdRewardsRewardIdPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<number> {
    const response = await this.apiV1RewardsStudentIdRewardsRewardIdPutRaw(
      requestParameters,
      initOverrides,
    )
    return await response.value()
  }
}
